import { Link } from "react-router-dom";
import { SIDE_CONTACTMENU, SIDE_MAINMENU } from "../../constants";
import { useAuth } from "../../Context/AuthContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { MyAccountHandSVG } from "../../assets/imageImport";
import { MyAccountMenuList } from "./myAccountMenuList";
import { PAGES } from "../../routeConfig";
import { handleCloseSideBar } from "../Common/common";
import { QuickOrderMain } from "../../View/QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { useGuestClickGuard, useGuestLoginPrompt } from "../../Context/hook/useGuestClickGuard";

export const SideBar = () => {
  const { userId, userName, role, isAuthenticated, companyId } = useAuth();
  const { logout } = useGlobalFunction();
  const isGuest = isAuthenticated === false;
  const handleGuestClick = useGuestClickGuard();
  const promptLogin = useGuestLoginPrompt();
  const handleSidebarGuestClick = (event) => {
    handleGuestClick(event);
    if (event.defaultPrevented) handleCloseSideBar();
  };
  const handleSidebarSignIn = () => {
    handleCloseSideBar();
    promptLogin();
  };
  return (
    <div className="sidebar-content">
      <div className="sidebar-menu-header">
        <div className="dropdown-myAccount-header">
          <h5>
            Hello{" "}
            <p>
              {isGuest ? "Guest" : userName}
              <MyAccountHandSVG />
            </p>
          </h5>
          {!isGuest && (
            <div className="accInfo-header mt-1">
              <span>Company Id :</span>
              <span>{companyId}</span>
            </div>
          )}
        </div>
      </div>
      <div className="sidebar-menu">
        <div className="sidebar-menu-list">
          <h4>Main Menu</h4>
          <div
            className="quick-link-list d-flex align-items-center justify-content-between"
            onClickCapture={handleSidebarGuestClick}
          >
            <div className="quick-links">
              <ul className="m-0 p-0 quick-menu quick-menu-effect">
                <li>
                  {/* <a href="#">
                    <span className="wes-shopping-cart" /> Quick Order
                  </a> */}
                  <a
                    type="btn"
                    data-bs-toggle={isGuest ? undefined : "offcanvas"}
                    data-bs-target={isGuest ? undefined : "#quickOrder-popup"}
                    aria-controls={isGuest ? undefined : "offcanvasRight"}
                  >
                    <span className="wes-shopping-cart" /> Quick Order{" "}
                  </a>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.BRAND}>
                    <span className="wes-shop-brand" /> Shop by Brands
                  </Link>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.NEWPRODUCTS_CT}>
                    <span className="wes-new-product" /> New Products
                  </Link>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.CLEARANCE_CT}>
                    <span className="wes-clearance" /> Clearance Products
                  </Link>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.BRANDS_CT}>
                    <span className="wes-shop-brand" /> Compatible Brands
                  </Link>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.ONLINE_CATALOGUE} data-guest-allow>
                    <span className="wes-catalogue" /> Catalogue eBook
                  </Link>{" "}
                </li>
              </ul>
            </div>
            <div className="quick-links">
              <ul className="m-0 p-0 quick-menu quick-menu-effect">
                <li>
                  {/* <Link onClick={handleCloseSideBar} to={PAGES.FAQ} data-guest-allow>
                    <i className="fa-regular fa-message" /> Help
                  </Link> */}
                  <Link onClick={handleCloseSideBar} to={PAGES.ABOUTUS} data-guest-allow>
                    <i className="fa-regular fa-message" /> About Us
                  </Link>
                </li>
                <li>
                  <Link onClick={handleCloseSideBar} to={PAGES.CONTACTUS} data-guest-allow>
                    <span className="wes-call" /> Contact Us
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <QuickOrderMain />
        </div>
        <div className="sidebar-menu-innerList">
          {!isGuest && <MyAccountMenuList />}
          <div className="dropdown-myAccount-footer">
            {isGuest ? (
              <a role="button" onClick={handleSidebarSignIn}>
                Sign in
              </a>
            ) : (
              <a role="button" onClick={logout}>
                Sign out
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
